import { BadgeListTable } from './BadgeListTable'
import withBadgeListTable from './withBadgeListTable'

const ConnectedBadgeListTable = withBadgeListTable(BadgeListTable)
export { ConnectedBadgeListTable as BadgeListTable }
